export default "__VITE_ASSET__CrFRLkJE__"